import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { NetworkContext } from '../../context/NetworkContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faCloudArrowDown, faXmark } from '@fortawesome/free-solid-svg-icons';

import useSecureStorage from '../../hooks/useSecureStorage';
import useQssMnemonic from '../../hooks/useQssMnemonic';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkHeaderText, checkMnemonic, checkPincode, checkUnlock, RootState } from '../../store';
import store from '../../store';

import i18next from 'i18next'

import * as bip39 from 'bip39'

import WebApp from '@twa-dev/sdk'

interface QssData {
    network: string
    name: string
    mnemonic: string
}

const QssSettingDataList: React.FC = () => {
    const { theme } = useContext(ThemeContext)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const { stopRequestTxData } = useContext(NetworkContext)
    const { getNetworkInfo } = useContext(DefaultTokenContext);
    const { setLocalMnemonicHash, setBlockChain, setLogout, getBlockChain, logOut } = useSecureStorage()
    const { getQssMnemonic, addQssMnemonic, clearQssMnemonic, removeQssMnemonic, editNameQssMnemonic } = useQssMnemonic()
    const [qssMnemonicList, setQssMnemonicList] = useState<QssData[]>([]);
    const [selNetworkName, setSelNetworkName] = useState('')

    const qssPassword = useSelector((state: RootState) => state.qssPassword.value);
    const selectQssIndex = useSelector((state: RootState) => state.selectQssIndex.value);
    let qSSIndex = -1;

    useEffect(() => {
        dispatch(checkHeaderText({ "link": "QssLoadDataList", "title": t('stack_header_message_23') }))
    }, [])

    useEffect(() => {
        const initializeAssets = async () => {
            try {
                // 현제 선택된 네트워크
                const selNetwork = await getBlockChain()
                if(null == selNetwork || '' === selNetwork) {
                    setSelNetworkName(process.env.REACT_APP_NETWORK_NAME!)
                }
                else {
                    setSelNetworkName(selNetwork)
                }

                // qss 저장된 데이터 로드
                const qssMnemonic = await getQssMnemonic(qssPassword, selNetwork)
                console.log(`QssSettingDataList qss 저장된 니모닉 리스트`, qssMnemonic)

                // 임시저장 qss 비밀번호 리셋
                // dispatch(checkQssPassword(''))

                if (true === qssMnemonic.result) {
                    if (0 < qssMnemonic.value.length) {
                        setQssMnemonicList(qssMnemonic.value)
                    }
                } else {
                    alert('qss setting mnemonic load error')
                    setTimeout(() => {
                        navigate('/CreateWallet')
                    }, 1000)
                }
            } catch (error) {
                console.error('Error qss load:', error)
                alert(`Error qSS load. Please Restart miniapp`)
                navigate('/SeeMoreScreen')
            }
        };

        initializeAssets();
    }, []);

    const handleQssDelMnemonic = async (index: number) => {
        qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_datalist_screen_message_03'), TgWebAppDelMnemonicCallBack)
    }

    /**
     * QSS 니모닉 삭제
     * @param isSuccess 
     * @returns 
     */
    const TgWebAppDelMnemonicCallBack = async (isSuccess: boolean) => {
        if (true !== isSuccess) {
            return
        }

        // 진행중인 DB TX 현행화 중단
		stopRequestTxData(true)

        let index = qSSIndex
        qSSIndex = -1
        try {
            const selectMnemonic: QssData = qssMnemonicList[index]

            if (null != selectMnemonic.mnemonic && '' !== selectMnemonic.mnemonic) {
                // 니모닉코드, 네트워크
                const trimmedSecretPhrase = selectMnemonic.mnemonic.trim()

                // 활성화된 네트워크 설정 정보
                const defaultNetworks = await getNetworkInfo('');
                const activeNetworks = defaultNetworks.filter(network => network.is_active);

                // 네트워크 별 저장된 QSS 니모닉코드 삭제
                let removeResult = false;
                for (const network of activeNetworks) {
                    removeResult = await removeQssMnemonic(qssPassword, network.symbol, trimmedSecretPhrase)
                    console.log(`QssSettingDataList handleQssDelMnemonic removeQssMnemonic: ${network.symbol}`, trimmedSecretPhrase);

                    if (true !== removeResult) {
                        console.log(`QssSettingDataList handleQssDelMnemonic 삭제 실패 : ${network.symbol}`, trimmedSecretPhrase);
                        break;
                    }
                }

                if (true === removeResult) {
                    WebApp.showPopup({ message: t('qss_setting_datalist_screen_message_04') }, () => {
                        // QSS 리스트 제거
                        setQssMnemonicList([])

                        // 더보기 > QSS 설정 페이지로 이동
                        navigate(`/QssSettingMnemonicScreen`, { replace: true, state: {} });
                    })
                } else {
                    alert(t('qss_setting_datalist_screen_message_08'));
                }
            }

        } catch (error) {
            console.warn(`Error Qss Load Data`, error);
        }
    };

    const handleQssEditMnemonicName = async (index: number) => {
        qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_datalist_screen_message_05'), TgWebAppEditMnemonicNameCallBack)
    }

    const TgWebAppEditMnemonicNameCallBack = async (isSuccess: boolean) => {
        if (true !== isSuccess) {
            return
        }

        let index = qSSIndex
        qSSIndex = -1
        try {
            // 변경한 니모닉이름 저장
            if (index >= 0 && index < qssMnemonicList.length) {
                const newName = qssMnemonicList[index]
                await editMnemonicName(newName.name, index)
            }
        } catch (error) {
            console.warn(`Error Qss Load Data`, error);
        }
    };

    // 선택한 QSS 니모닉으로 지갑을 복구
    const handleQssRestoreWallet = async (index: number) => {
        qSSIndex = index;
        WebApp.showConfirm(t('qss_setting_datalist_screen_message_06'), TgWebAppQssRestoreWalletCallBack)
    }

    const TgWebAppQssRestoreWalletCallBack = async (isSuccess: boolean) => {
        if(true !== isSuccess) {
            return
        }

        let index = qSSIndex
        qSSIndex = -1
        try {
            // QSS 지갑복구 시작
            const selectMnemonic : QssData = qssMnemonicList[index]

            if(null != selectMnemonic.mnemonic && '' !== selectMnemonic.mnemonic) {
                const trimmedSecretPhrase = selectMnemonic.mnemonic.trim()
                const storeMnemonic = trimmedSecretPhrase.split(/\s+/)
                const network = selectMnemonic.network.trim()
                console.log(`QSS 지갑복구 network`, network)

                // 복구단계 진행 시작
                if (bip39.validateMnemonic(trimmedSecretPhrase)) {
                    // redux 에 비밀복구코드 배열 임시 저장
                    const jsonMnemonic = JSON.stringify(storeMnemonic)
                    dispatch(checkMnemonic(jsonMnemonic))

                    // redux에 pincode 저장
                    const unlockPincode = store.getState().unlockPincode.value;
                    dispatch(checkPincode(unlockPincode))

                    // 로컬 저장 데이터 삭제
                    await logOut();

                    // 복구한 QSS 니모닉의 블록체인 네트워크 값 로컬 저장
                    await setBlockChain(network)

                    // 복구에 사용한 니모닉해시 로컬 저장
                    await setLocalMnemonicHash(trimmedSecretPhrase)

                    // loading 표시 위해 지갑 register 상태 변경
                    await setLogout()

                    // 지갑복구 비밀번호 입력화면으로 이동
                    setTimeout(() => {
                        // 언락상태 잠금으로 변경
                        dispatch(checkUnlock(false))
                        navigate('/WalletRecoveryLoading', { replace: true, state: {} });
                        // navigate('/WalletRecoveryProtection', { replace: true, state: {} });
                    }, 1000)
                } else {
                    // 복구에 사용한 니모닉해시 저장
                    alert('Error validate Mnemonic');
                }
            }
        } catch (error) {
            console.warn(`Error Qss Load Data`, error);
        }
	};


    // QSS 니모닉 이름 변경
    const editMnemonicName = async (newName: string, index: number) => {
        try {
            const selNetwork = await getBlockChain()
            const editResult = await editNameQssMnemonic(qssPassword, newName, index, selNetwork)

            if(true === editResult) {
                // 안내표시
                WebApp.showPopup({ message: t('qss_setting_datalist_screen_message_07') })

                // qSS 니모닉 다시 불러와 리스트 갱신
                const selNetwork = await getBlockChain()
                const qssMnemonic = await getQssMnemonic(qssPassword, selNetwork)
                // console.log(`TgWebAppDelMnemonicCallBack QssSettingDataList qss 저장된 니모닉 리스트`, qssMnemonic)
                // console.log(`qssMnemonic.result : ${qssMnemonic.result}`)
                // console.log(`qssMnemonic.value.length : ${qssMnemonic.value.length}`)

                if (true === qssMnemonic.result) {
                    if (0 < qssMnemonic.value.length) {
                        setQssMnemonicList(qssMnemonic.value)
                    } else {
                        // qss 니모닉 usestate 초기화
                        setQssMnemonicList([])
                    }
                } else {
                    alert('qss setting edit mnemonic name load error')
                }
            } else {
                alert('qss setting edit mnemonic name save error')
                WebApp.showPopup({ message: t('qss_setting_datalist_screen_message_08') })
            }

        } catch (error) {
            console.error('Error Edit QSS Mnemonic name:', error)
        }
    }

    // 니모닉 이름 입력 변경
    const updateMnemonicName = (index: number, newName: string) => {
        setQssMnemonicList((prevList) => {
            const updatedList = [...prevList];
            updatedList[index] = { ...updatedList[index], name: newName };
            return updatedList;
        });
    };

    const handleConfirmDelete = async () => {
    }

    const styles = {
        container: {
            padding: "60px 5px 24px",
        } as React.CSSProperties,
        inner: {
            display: "flex",
            justifyContent: 'space-between',
            width: "100%"
        } as React.CSSProperties,
        text: {
            fontSize: 16,
            marginBottom: 16,
            textAlign: 'center'
        } as React.CSSProperties,
        button: {
            padding: "24px 12px",
            borderRadius: 10,
            width: '100%',
            position: 'absolute',
            bottom: 60,
            marginBottom: 0,
            justifyContent: 'center'
        } as React.CSSProperties,
        transactionItem: {
            display: "flex",
            alignItems: 'center',
            padding: "15px 15px",
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.line_neutral}`
        } as React.CSSProperties,
        transactionDetails: {
            flex: 1
        } as React.CSSProperties,
        transactionName: {
            fontSize: 15
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
        xIcon: {
            width: 15,
            height: 15
        } as React.CSSProperties,
        modalBackground: {
            display: "flex",
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: theme.background_alternative,
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0
        } as React.CSSProperties,
        modalContainer: {
            width: '90%',
            backgroundColor: 'white',
            borderRadius: 10,
            padding: '20px',
            border: `1px solid ${theme.line_normal}`,
            boxSizing: "border-box"
        } as React.CSSProperties,
        modalTitle: {
            fontSize: 18,
            textAlign: 'center',
            marginBottom: 10
        } as React.CSSProperties,
        modalMessage: {
            fontSize: 14,
            textAlign: 'center'
        } as React.CSSProperties,
        modalButtons: {
            display: "flex",
            width: '100%',
            borderTop: `1px solid ${theme.line_alternative}`,
            marginTop: 20
        } as React.CSSProperties,
        cancelButton: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 10,
            borderRight: `1px solid ${theme.line_alternative}`,
        } as React.CSSProperties,
        cancelButtonText: {
            fontSize: 16
        } as React.CSSProperties,
        confirmButton: {
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            paddingVertical: 10
        } as React.CSSProperties,
        confirmButtonText: {
            fontSize: 16
        } as React.CSSProperties,
        infoModalContent: {
            backgroundColor: 'white',
            padding: 20,
            borderRadius: 20,
            alignItems: 'center'
        } as React.CSSProperties,
        infoModalHeader: {
            display: "flex",
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
            marginBottom: 20,
            padding: "0 10px",
        } as React.CSSProperties,
        deleteButton: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
        } as React.CSSProperties,
        inputMnemonicName: {
            width: "100%",
            borderTop: "none",
            borderRight: "none",
            borderLeft: "none",
            borderBottom: "none",
            outline: "none",
            fontSize: 16,
            height: "40px",
            background: "inherit"
        } as React.CSSProperties,
    }

    return (
        <div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
            <div onClick={() => { }} style={styles.inner}>
                <div style={{ flex: 1, justifyContent: 'flex-start', gap: '5px' }}>
                    {qssMnemonicList.map((item, index) => (
                        item.network.toLowerCase() === selNetworkName.toLowerCase() && selectQssIndex === index && (
                            <>
                            <div key={index} style={{ ...styles.transactionItem, backgroundColor: theme.fill_normal, flexDirection: 'column' }}>
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <div style={styles.transactionAmountContainer}>
                                        <button onClick={() => handleQssDelMnemonic(index)} style={styles.deleteButton}>
                                            <FontAwesomeIcon icon={faXmark} color={theme.text_01} style={{ fontSize: '20px', marginRight: '5px' }} />
                                        </button>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <span style={{ ...styles.transactionName, color: theme.label_strong }}>
                                            <input
                                                key={index}
                                                value={item.name}
                                                onChange={(e) => updateMnemonicName(index, e.target.value)}
                                                placeholder={i18next.t('qss_create_secret_phrase_confirm_screen_message_06')}
                                                style={{
                                                    ...styles.inputMnemonicName,
                                                    borderBottom: `1px solid ${theme.line_alternative}`,
                                                    color: theme.label_strong,
                                                }}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', width: '97%' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleQssRestoreWallet(index)}>
                                        <FontAwesomeIcon icon={faCloudArrowDown} color={theme.text_01} style={{ marginRight: '5px' }} />
                                        <span style={{ color: theme.text_01 }}>{t('qss_setting_datalist_screen_message_09')}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => handleQssEditMnemonicName(index)}>
                                        <FontAwesomeIcon icon={faFloppyDisk} color={theme.text_01} style={{ fontSize: '20px', marginRight: '5px' }} />
                                        <span style={{ color: theme.text_01 }}>{t('qss_setting_datalist_screen_message_10')}</span>
                                    </div>
                                </div>
                            </div>
                            </>
                        )
                    ))}

                    {qssMnemonicList.length === 0 && (
                        <div key="1" style={{ ...styles.transactionItem, backgroundColor: theme.fill_normal }}>
                            <div onClick={() => { }} style={styles.transactionDetails}>
                                <span style={{ ...styles.transactionName, color: theme.label_strong }}>
                                    {t('qss_setting_datalist_screen_message_01')}
                                </span>
                            </div>
                            <div style={styles.transactionAmountContainer}>
                            </div>
                        </div>
                    )}

                </div>
            </div>
            {/* {renderInfoModal()} */}
        </div>
    )
}

export default QssSettingDataList
